import styled from 'styled-components';

import { media } from 'utils/detection';

export default styled.div`
  width: 100%;
  margin: 50px 0px;

  ${media.medium`
    margin: 50px 0;
  `}

  .slick-list {
    overflow: visible;
  }
`;
